import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { Injectable, Provider } from '@angular/core';
import { first } from 'rxjs';

@Injectable()
export class TranslateablePaginator extends MatPaginatorIntl {
  translateService: TranslateService;
  range = '';

  constructor(translateService: TranslateService) {
    super();
    this.translateService = translateService;

    this.translateService.onLangChange.subscribe(() => {
      this.updateLanguage();
    });
    this.updateLanguage();
  }

  updateLanguage() {
    const itemsPerPage = 'components.paginator.items-per-page';
    const range = 'components.paginator.range';
    this.translateService
      .get([itemsPerPage, range])
      .pipe(first())
      .subscribe((translation) => {
        this.itemsPerPageLabel = translation[itemsPerPage];
        this.range = translation[range];
        this.changes.next();
      });
  }

  override getRangeLabel = (page: number, pageSize: number, length: number) => {
    return this.range
      .replace('{{page}}', (page + 1).toString())
      .replace('{{numPages}}', Math.ceil(length / pageSize).toString());
  };
}

export function provideTranslateablePaginator(): Provider {
  return { provide: MatPaginatorIntl, useClass: TranslateablePaginator };
}
